import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DashboardComponent} from './dashboard.component';
import {DashboardRoutingModule} from 'src/app/main/dashboard/dashboard-routing.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {MyServicesModule} from '../service/my-services/my-services.module';
import {IconsModule} from '../../icons/icons.module';
import {CircleProgressBarModule} from '../../components/circle-progress-bar/circle-progress-bar.module';
import {TicketsModule} from '../../components/tickets/tickets.module';
import { MatSelectModule } from '@angular/material/select';
import { TableModule } from 'src/app/table/table.module';
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatDividerModule } from '@angular/material/divider';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';

@NgModule({
  declarations: [
    DashboardComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MatDividerModule,
    DashboardRoutingModule,
    MyServicesModule,
    IconsModule,
    CircleProgressBarModule,
    TicketsModule,
    MatSelectModule,
    TableModule,
    ToolbarModule,
    NgxEchartsModule.forRoot({
      echarts
    }),
  ]
})
export class DashboardModule {
}
